// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ok-2";
export var chatLink = "_ok-0";
export var chatText = "_ok-1";